import { Alert, Row } from "antd";
import { ReactNode, useCallback, useMemo } from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./styles.scss";

type Props = {
  onClose: () => void;
  title: string;
  description: string;
  actionLabel: string;
};

export const PortalNotification = ({
  onClose,
  title,
  description: notificationDescription,
  actionLabel,
}: Props) => {
  const onClickLink = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      onClose();
    },
    [onClose],
  );

  const description: ReactNode = useMemo(
    () => (
      <Row className="info-container">
        <Row className="icon-container justify-center mr-4">
          <ExclamationCircleOutlined className="text" />
        </Row>
        <Row className="notification-desc align-center justify-space-between">
          <Row className="d-block">
            <p className="my-0 text w-500">{title}</p>
            <p className="text-md desc-title">{notificationDescription}</p>
          </Row>
          <Link
            to="#"
            className="text-md w-500 ant-btn-link"
            onClick={onClickLink}
          >
            {actionLabel}
          </Link>
        </Row>
      </Row>
    ),
    [actionLabel, notificationDescription, onClickLink, title],
  );

  return (
    <Alert
      className="mt-4 pa-4 w-100 warn__container"
      description={description}
    />
  );
};
